import Promise from 'bluebird'
import _find from 'lodash/find'

import urlUtils from 'utils/urlUtils'
import stringUtils from 'utils/stringUtils'
import TRACKING_EVENTS from 'constants/trackingEvents'
import store from 'src/store'

const TRACKING_EVENTS_TYPES = Object.keys(TRACKING_EVENTS).map((key) => {
  return {
    key,
    value: TRACKING_EVENTS[key],
  }
})
// import SURFSIDE_TRACKING_EVENTS from './constants/trackingEvents';

const BASE_URL = 'https://edge.surfside.io'

function makeRequest(method, path, query, body, options = {}) {
  let fullUrl = urlUtils.combinePaths(BASE_URL, path)

  fullUrl = urlUtils.addQueryStringParams(fullUrl, query)

  const data = {
    method,
    headers: options.headers || {},
    body,
    mode: 'no-cors',
  }

  return Promise.resolve(fetch(fullUrl, data)).catch((err) => {
    console.log('err', err) //eslint-disable-line

    return null
  })
}

function get(path, query, body) {
  return makeRequest('GET', path, query, body)
}

function getBaseOptions(options = {}) {
  return {
    url: encodeURIComponent(window.location.href.split('?')[0]),
    page: window.location.pathname ? encodeURIComponent(window.location.pathname) : undefined,
    aid: options.aid,
    cid: options.cid,
    lid: options.lid,
  }
}

export default {
  pageView(options) {
    if (!options) throw new Error('options')

    return get('/track/pv', Object.assign(options, getBaseOptions(options))).then(() => {
      return get('/id/uid')
    })
  },
  track(event, options) {
    if (!event) throw new Error('event')
    if (!options) throw new Error('options')

    const trackingEventType = _find(TRACKING_EVENTS_TYPES, {
      value: event,
    })

    if (!trackingEventType) throw new Error(`no surfside tracking event for event ${event}`)

    const trackingEvent = trackingEventType.value

    const currentUser = store.state.user.current || {}

    if (trackingEvent === TRACKING_EVENTS.ViewedItem) {
      return get(
        '/comm/item',
        Object.assign({}, getBaseOptions(options), {
          uemail: currentUser.email,
          indent: currentUser.id,
          cint: 'view_item',
          ciid: options.inventoryId,
          cin: options.inventoryName,
          cic: stringUtils.capitalize(options.inventoryType),
          civ: options.inventoryCannabisType,
          cip: options.price,
        })
      )
    } else if (trackingEvent === TRACKING_EVENTS.AddedItemToCart) {
      return get(
        '/comm/item',
        Object.assign({}, getBaseOptions(options), {
          uemail: currentUser.email,
          indent: currentUser.id,
          cint: 'add_to_bag',
          ciid: options.inventoryId,
          cin: options.inventoryName,
          cic: stringUtils.capitalize(options.inventoryType),
          civ: options.inventoryCannabisType,
          cip: options.price,
          ciq: options.quantity,
        })
      )
    } else if (trackingEvent === TRACKING_EVENTS.StartedCheckoutItem) {
      return get(
        '/comm/item',
        Object.assign({}, getBaseOptions(options), {
          uemail: currentUser.email,
          indent: currentUser.id,
          cint: 'begin_checkout',
          ciid: options.inventoryId,
          cin: options.inventoryName,
          cic: stringUtils.capitalize(options.inventoryType),
          civ: options.inventoryCannabisType,
          cip: options.price,
          ciq: options.quantity,
        })
      )
    } else if (trackingEvent === TRACKING_EVENTS.StartedCheckout) {
      return get(
        '/comm/order',
        Object.assign({}, getBaseOptions(options), {
          uemail: currentUser.email,
          indent: currentUser.id,
          cint: 'begin_checkout',
          coid: options.cartId,
          cval: options.total,
        })
      )
    } else if (trackingEvent === TRACKING_EVENTS.PurchasedItem) {
      return get(
        '/comm/item',
        Object.assign({}, getBaseOptions(options), {
          uemail: currentUser.email,
          indent: currentUser.id,
          cint: 'purchase_item',
          ciid: options.inventoryId,
          cin: options.inventoryName,
          cic: stringUtils.capitalize(options.inventoryType),
          civ: options.inventoryCannabisType,
          cip: options.price,
          ciq: options.quantity,
        })
      )
    } else if (trackingEvent === TRACKING_EVENTS.CompletedOrder) {
      return get(
        '/comm/order',
        Object.assign({}, getBaseOptions(options), {
          uemail: currentUser.email,
          indent: currentUser.id,
          cint: 'purchase_order',
          coid: options.orderId,
          cval: options.total,
        })
      ).then(() => {
        return get('/id/uid')
      })
    }

    console.log(`not handling surfside event ${event}`) //eslint-disable-line

    return Promise.resolve(null)
  },
}



// WEBPACK FOOTER //
// ./src/lib/analyticsIntegrationClients/surfside/client.js